import { FunctionComponent, PropsWithChildren } from 'react';

import Box from '../Box/Box';
import TableCell from '../TableCell/TableCell';
import TableRow from '../TableRow/TableRow';
import ExpandIconButton from './ExpandIconButton';
import { TableRowExpandablePropsModel } from './models/table-row-expandable-props.model';

const TableRowExpandable: FunctionComponent<TableRowExpandablePropsModel> = ({
  children,
  colSpan,
  expandComponent,
  isExpanded,
  onExpandRow,
  currentRowIndex,
  changePrompt,
  ...otherProps
}: PropsWithChildren<TableRowExpandablePropsModel>) => {
  return (
    <>
      <TableRow key={`row-to-expand-${currentRowIndex}`} {...otherProps}>
        {children}
        <TableCell sx={{ width: '25px', position: 'relative' }}>
          <Box
            sx={{
              position: 'absolute',
              right: '0',
              top: '50%',
              transform: 'translateY(-50%)',
              '& button': {
                padding: 0,
              },
            }}
          >
            <ExpandIconButton
              isExpanded={isExpanded}
              onExpandRow={onExpandRow}
              changePrompt={!!changePrompt}
              currentRowIndex={currentRowIndex}
            />
          </Box>
        </TableCell>
      </TableRow>
      {isExpanded && (
        <TableRow key={`row-to-be-expanded-${currentRowIndex}`}>
          <TableCell colSpan={colSpan}>{expandComponent}</TableCell>
        </TableRow>
      )}
    </>
  );
};

export default TableRowExpandable;
